import { get } from 'lodash'

const pages = state => get(state.digitalOM, 'sections[0].data', [])
const sections = state => get(state.digitalOM, 'sections', [])
const address = state => {
    var addressList = []
    if (state.digitalOM.address !== undefined) {
        Object.keys(state.digitalOM.address).forEach((key, index) => {
            if (state.digitalOM.address[key] !== null && state.digitalOM.address[key] !== '') {
                addressList.push(state.digitalOM.address[key])
            }
        })
    }
    return {
        fullAddress: addressList.join(','),
        address: state.digitalOM.address
    }
}

export default {
    pages,
    sections,
    address
}



// WEBPACK FOOTER //
// ./src/state/modules/dom/getters.js